import * as Yup from "yup";
import { regex } from "../../../constants";

export default Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string()
    .required("Email is required")
    .matches(regex.EMAIL_REGEX, "Invalid email address"),
});
